import { FormattedMessage } from 'react-intl';

import { PickerOnboardingDialog } from '#src/components/missions/picker/PickerOnboardingDialog/index.tsx';

import leftCard from './assets/left-card.webp';
import rightCard from './assets/right-card.webp';
import twoCards from './assets/two-cards.webp';

type Props = {
  onClose: () => void;
  cardsCount: number;
};
export const DropChallengePickerOnboardingDialog = ({
  onClose,
  cardsCount,
}: Props) => {
  return (
    <PickerOnboardingDialog
      onClose={onClose}
      leftImg={leftCard}
      rightImg={rightCard}
      mobileImg={twoCards}
      greenText={
        <FormattedMessage
          id="missions.dropChallenge.onboarding.description"
          defaultMessage="WIN A 4★ OR 5★ CARD"
        />
      }
      mainText={
        <FormattedMessage
          id="missions.dropChallenge.onboarding.title"
          defaultMessage="Scrap Challenge"
        />
      }
      secondaryText={
        <FormattedMessage
          id="missions.dropChallenge.onboarding.subtitle"
          defaultMessage="Scrap {cardsCount, number} for greatness"
          values={{ cardsCount }}
        />
      }
      captionText={
        <FormattedMessage
          id="missions.dropChallenge.onboarding.caption"
          defaultMessage="Rules change daily"
        />
      }
    />
  );
};
